var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuaSunnat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.074,
    height: 224.891,
    viewBox: "0 0 185.074 224.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7957",
    "data-name": "Group 7957",
    transform: "translate(24781.359 21452.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39271",
    "data-name": "Path 39271",
    d: "M180.469,115.779a101.963,101.963,0,0,0-6.883-7.961s-4.1-2.928-4.1-13.912V63.148s0-2.637,2.2-2.637c0,0,13.183,2.485,13.031,16.257L184.57,81.9s10.109,0,15.091,8.493c0,0,4.392,6.154,3.511,16.555",
    transform: "translate(-24929.563 -21380.953)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39272",
    "data-name": "Path 39272",
    d: "M171.863,76.38V64.015a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5V87.7",
    transform: "translate(-24916.871 -21396.961)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39273",
    "data-name": "Path 39273",
    d: "M173.914,79.312V61.7a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5v38.65",
    transform: "translate(-24905.92 -21409.293)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39274",
    "data-name": "Path 39274",
    d: "M175.965,80.741V63.134a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5V92.657",
    transform: "translate(-24894.973 -21401.664)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39275",
    "data-name": "Path 39275",
    d: "M178.016,81.923V64.316a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5v38.028",
    transform: "translate(-24884.023 -21395.354)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39276",
    "data-name": "Path 39276",
    d: "M178.33,102.6s0-7.688,4.766-12.461c7-7,6.243-16.682,6.243-16.682V64.572",
    transform: "translate(-24882.348 -21359.273)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39277",
    "data-name": "Path 39277",
    d: "M209.63,115.779a101.983,101.983,0,0,1,6.883-7.961s4.1-2.928,4.1-13.912V63.148s0-2.637-2.2-2.637c0,0-13.183,2.485-13.037,16.257l.152,5.128s-10.109,0-15.091,8.493c0,0-4.392,6.154-3.511,16.555",
    transform: "translate(-24837.078 -21380.953)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39278",
    "data-name": "Path 39278",
    d: "M200.715,76.38V64.015a6.5,6.5,0,0,0-6.5-6.5h0a6.5,6.5,0,0,0-6.5,6.5V87.7",
    transform: "translate(-24832.25 -21396.961)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39279",
    "data-name": "Path 39279",
    d: "M198.663,79.312V61.7a6.5,6.5,0,0,0-6.5-6.5h0a6.5,6.5,0,0,0-6.5,6.5v38.65",
    transform: "translate(-24843.197 -21409.293)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39280",
    "data-name": "Path 39280",
    d: "M196.612,80.741V63.134a6.5,6.5,0,0,0-6.5-6.5h0a6.5,6.5,0,0,0-6.5,6.5V92.657",
    transform: "translate(-24854.146 -21401.664)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39281",
    "data-name": "Path 39281",
    d: "M194.562,81.923V64.316a6.5,6.5,0,0,0-6.5-6.5h0a6.5,6.5,0,0,0-6.5,6.5v38.028",
    transform: "translate(-24865.094 -21395.354)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39282",
    "data-name": "Path 39282",
    d: "M192.592,102.6s0-7.688-4.766-12.461c-7-7-6.243-16.682-6.243-16.682V64.572",
    transform: "translate(-24865.115 -21359.273)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3648",
    "data-name": "Rectangle 3648",
    width: 52.875,
    height: 27.738,
    transform: "translate(-24676.746 -21256.352)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3649",
    "data-name": "Rectangle 3649",
    width: 52.875,
    height: 27.738,
    transform: "translate(-24752.668 -21256.352)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39283",
    "data-name": "Path 39283",
    d: "M348.438,261.833V131.046s-10.192-66.575-90.907-91.008L257.4,40l-.133.038c-80.715,24.433-90.907,91.008-90.907,91.008V261.833",
    transform: "translate(-24946.223 -21490.441)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuaSunnat);
export default __webpack_public_path__ + "static/media/Dua_Sunnat.bba1f35b6a36d6f66ef11641523447bc.svg";
export { ForwardRef as ReactComponent };